export * from './delete-besichtigungs-status-request.interface';
export * from './delete-besichtigungs-status-response.interface';
export * from './delete-besichtigungs-status.shapes';
